var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFillToolbox = function SvgFillToolbox(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "components_Icon_menu-svg_fill--toolbox_svg-a",
    width: 25,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M.725 0h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#components_Icon_menu-svg_fill--toolbox_svg-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.475 8.23h6.5V6.309a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H9.783a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212zM4.13 19.5a.87.87 0 0 1-.644-.26.87.87 0 0 1-.26-.644v-3.98h3.692v.25q0 .318.216.534a.73.73 0 0 0 .535.215q.318 0 .534-.215a.73.73 0 0 0 .215-.535v-.25h8.616v.25q0 .319.216.535a.73.73 0 0 0 .534.215q.319 0 .534-.215a.73.73 0 0 0 .216-.535v-.25h3.692v3.981q0 .383-.26.644a.87.87 0 0 1-.644.26zm-.904-5.77v-3.688q0-.761.525-1.286t1.283-.525h2.942V6.308q0-.758.525-1.283T9.783 4.5h5.884q.758 0 1.283.525t.525 1.283V8.23h2.942q.758 0 1.283.525t.525 1.286v3.689h-3.692v-.866a.73.73 0 0 0-.216-.534.73.73 0 0 0-.535-.215.73.73 0 0 0-.534.215.73.73 0 0 0-.215.534v.866H8.417v-.866a.73.73 0 0 0-.215-.534.73.73 0 0 0-.535-.215.73.73 0 0 0-.534.215.73.73 0 0 0-.216.534v.866z"
  }))));
};
export default SvgFillToolbox;